import styled from 'styled-components';

export const Wrapper = styled.div`
	max-width: 1245px;
	width: 100%;
	padding: 0 20px;
	margin: 0 auto;
	position: relative;
	z-index: 10;
	.main-wrapper {
		margin-top: 60px;
		position: relative !important;
		.flex {
			display: flex;
			justify-content: space-between;
			gap: 50px;
			.left-box {
				margin-left: 2px;
				margin-top: 45px;
				p {
					font-size: 18px;
					font-weight: 500;
					line-height: 140%;
					line-height: normal;
					display: inline-flex;
					gap: 6px;
					position: relative;
					top: 5px;
				}
				h2 {
					margin-top: 22px;
					font-size: 40px;
					font-weight: 700;
					line-height: 150%;
					max-width: 438px;
					height: 120px;
					/* word-break: keep-all; */
					width: 100%;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}
				.more-btn {
					margin-top: 54px;
					border-radius: 44.828px;
					background: #000;
					color: #fff;
					text-align: center;
					font-size: 16px;
					font-weight: 500;
					line-height: 52px;
					width: 160px;
					height: 54px;
					cursor: pointer;
					transition: all 0.3s;

					&:hover {
						opacity: 0.8;
					}
				}
			}
			.right-box {
				max-width: 690px;
				width: 100%;
				/* padding-left: 30px; */
				.banner {
					max-width: 660px;
					width: 100%;
					height: 0;
					padding-bottom: 66%;
					border-radius: 30px;
					background-size: cover;
					background-position: center;
					background-repeat: no-repeat;
					transition: all 0.3s;
					position: relative;

					&:after {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						border-radius: 30px;
						filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1));
						content: '';
					}
					&:hover {
						opacity: 0.8;
					}
				}
			}
		}
		.swiper-pagination {
			display: flex;
		}
		.swiper-pagination-bullet {
			width: 48px;
			height: 1px;
			cursor: pointer;
			border-radius: 0;
			margin-top: -22px !important;

			box-sizing: content-box;
			position: relative;
		}
		.swiper-pagination-bullet::before {
			content: '';
			position: absolute;
			top: -20px;
			bottom: -10px;
			left: 0px;
			right: 0px;
			padding: 20px;
		}

		.swiper-pagination-bullet-active {
			background-color: #000;
		}
		.swiper-button-next {
			background: url(/images/icon-next.svg) no-repeat;
			background-position: center;
			width: 20px;
			right: -80px;
			z-index: 10;
		}

		.swiper-button-prev {
			background: url(/images/icon-next.svg) no-repeat;
			width: 20px;
			left: -98px;
			z-index: 10;
			transform: rotate(180deg);
		}

		.swiper-button-next::after,
		.swiper-button-prev::after {
			display: none;
		}
		.swiper-button-prev.swiper-button-disabled,
		.swiper-button-next.swiper-button-disabled {
			opacity: 0.2;
		}
	}
	.article-wrap {
		margin-top: 98px;
		margin-left: 2px;

		.title {
			font-size: 30px;
			font-weight: 700;
			line-height: 140%;
			margin-bottom: 38px;
		}
		.flex-wrap {
			display: flex;
			justify-content: space-between;
			.left-box {
				padding-right: 50px;
				width: 100%;
				.line {
					border-top: 1px solid #eee;
					margin: 50px 0 54px 0;
					&:last-child {
						border-top: none;
					}
				}
			}
		}
		.card-box {
			display: block;
			/* border-bottom: 1px solid #eee; */
			/* padding-bottom: 49px; */
			/* margin-bottom: 50px; */
			position: relative;
			z-index: 10;
			&:last-child {
				border-bottom: none;
			}
		}
		.article-card {
			display: flex;
			gap: 37px;
			align-items: center;
			cursor: pointer;
			transition: all 0.3s;

			&:hover {
				opacity: 0.8;
			}

			.article-img {
				width: 250px;
				height: 0;
				padding-bottom: 70.4%;
				border-radius: 16px;
				background-repeat: no-repeat !important;
				background-size: cover !important;
				background-position: center !important;
				background: #f7f7f7;
			}
			.text-box {
				max-width: 584px;
				width: 100%;
				.tag-box {
					display: flex;
					gap: 12px;
					.cate {
						color: #e99210;
						font-size: 13px;
						font-weight: 400;
						line-height: 140%;
						margin-top: 5px;
					}
				}
				h3 {
					margin-top: 7px;
					font-size: 26px;
					font-weight: 700;
					line-height: 140%;
				}
				.content {
					margin-top: 9px;
					color: #888;
					font-size: 14px;
					font-weight: 400;
					line-height: 160%;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					padding-right: 30px;
				}
				.flex {
					display: flex;
					margin-top: 16px;
					align-items: center;
					.user-box {
						display: flex;
						align-items: center;
						cursor: pointer;
						a {
							display: flex;
						}
						.people {
							display: flex;
							align-items: center;
							margin-right: 26px;
						}
						.alone {
							display: flex;
							align-items: center;
							gap: 10px;
						}
						.user {
							width: 20px;
							height: 20px;
							border-radius: 50%;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
							border: 0.5px solid #eee;
							margin-left: -5px;
						}
					}
					p {
						font-size: 13px;
						color: #000;
						font-weight: 400;
						line-height: 140%;
						margin-right: 27px;
					}
					.name {
						font-size: 13px;
						color: #000;
						font-weight: 400;
						line-height: 140%;
						margin-right: 27px;
						position: relative;
						display: flex;
						align-items: center;
						gap: 4px;
						img {
							width: 16px;
						}
						&::after {
							position: absolute;
							content: '';
							width: 1px;
							height: 12px;
							background-color: #eee;
							left: -13px;
							top: 50%;
							transform: translateY(-50%);
						}
					}
					.date {
						color: #000;
						font-size: 13px;
						font-weight: 400;
						line-height: 140%;
						position: relative;

						&::before {
							position: absolute;
							content: '';
							width: 1px;
							height: 12px;
							background-color: #eee;
							left: -13px;
							top: 50%;
							transform: translateY(-50%);
						}
					}
				}
			}
		}
		.right-box {
			max-width: 256px;
			width: 100%;
			position: relative;
			.shapes-box {
				width: 100%;
				height: 320px;
				border-radius: 18px;
				padding: 30px;
				position: relative;
				top: -82px;
				left: -2px;
				margin-bottom: 30px;

				.shapes-card {
					width: 100%;
					height: 100%;
					background-size: cover;
					background-repeat: no-repeat;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					cursor: pointer;
					transition: all 0.3s;

					&:hover {
						opacity: 0.8;
					}
				}
				.article-title {
					font-size: 20px;
					font-weight: 700;
					line-height: normal;
					position: relative;
					z-index: 1;
					opacity: 0.6;
					font-family: 'GmarketSans';
				}
				.total {
					font-size: 14px;
					opacity: 0.6;
					font-weight: 400;
					line-height: normal;
					position: absolute;
					right: 30px;
					bottom: 30px;
				}
			}
			.more-btn {
				width: 134px;
				height: 54px;
				position: absolute;
				margin-top: -72px;
				left: 50%;
				transform: translateX(-50%);
				a {
					display: block;
				}
				.more {
					height: 100%;
					border-radius: 66px;
					border: 1px solid #eee;
					background: #fff;
					display: flex;
					gap: 8px;
					justify-content: center;
					cursor: pointer;
					transition: all 0.3s;
					&:hover {
						opacity: 0.8;
					}
					img {
						width: 18px;
					}
					p {
						text-align: center;
						font-size: 14px;
						font-weight: 600;
						line-height: 52px;
					}
				}
			}
		}
		.btn-wrap {
			max-width: 894px;
			width: 100%;
			display: flex;
			justify-content: center;
			position: relative;
			top: 25px;
			.more {
				border-radius: 96px;
				border: 1px solid #eee;
				background: #fff;
				display: flex;
				display: inline-flex;
				justify-content: center;
				align-items: center;
				gap: 8px;
				width: 151px;
				height: 54px;
				cursor: pointer;
				transition: all 0.3s;
				&:hover {
					opacity: 0.8;
				}
				p {
					font-size: 14px;
					font-weight: 600;
					line-height: 150%;
				}
			}
		}
	}
	.result {
		width: 100%;
		display: flex;
		justify-content: center;
		height: 624px;
		position: relative;

		.result-box {
			width: 279px;
			height: 168px;
			background-image: url(/images/result.png);
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			p {
				padding-top: 44px;
				text-align: center;
				font-size: 18px;
				font-weight: 400;
				line-height: 150%;
			}
		}
	}
	@media screen and (max-width: 1024px) {
		.article-wrap {
			.flex-wrap {
				.left-box {
					padding-right: 30px;
					width: 100%;
				}
			}

			.article-card {
				gap: 20px;

				.text-box {
					max-width: 584px;
					width: 100%;

					h3 {
						margin-top: 7px;
						font-size: 26px;
					}

					.flex {
						.user-box {
							display: flex;
						}
						p {
							margin-right: 14px;
						}
						.name {
							margin-right: 14px;

							&::after {
								left: -7px;
							}
						}
						.date {
							&::before {
								left: -7px;
								top: 50%;
								transform: translateY(-50%);
							}
						}
					}
				}
			}
		}
		.flex {
			.left-box {
				h2 {
					font-size: 28px !important;
				}
				.more-btn {
					margin-top: 48px !important;
				}
			}
		}
	}
	@media screen and (max-width: 768px) {
		/* padding-top: 54px; */
		.main-wrapper {
			margin-top: 7px;
			.flex {
				flex-wrap: wrap;
				.left-box {
					margin-left: 2px;
					margin-top: 20px;
					p {
						font-size: 14px;
						/* margin-top: 25px; */
						margin-top: 0;
						margin-left: 6px;

						img {
							width: 18px;
						}
					}
					h2 {
						margin-top: 14px;
						margin-left: 8px;
						font-size: 24px !important;
						max-width: 250px;
						height: 72px;
						width: 100%;
						overflow: hidden;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
					}
					.more-btn {
						margin-top: 20px !important;
						margin-left: 8px;
						border-radius: 33.621px;
						font-size: 12px;
						line-height: 38px;
						width: 120px;
						height: 40px;
					}
				}
				.right-box {
					margin-top: 28px;
					width: 100%;
					padding-left: 0;
					.banner {
						width: 100%;
						height: 0;
						padding-bottom: 75%;
						border-radius: 20px;
					}
				}
			}
			.swiper-wrapper {
				padding-bottom: 27px;
			}
			.swiper-pagination {
				display: flex;
				justify-content: center;
			}
			.swiper-pagination-bullet {
				margin-top: 0px !important;
			}
			.swiper-button-next {
				background: url(/images/icon-mo-next.svg) no-repeat;
				background-position: center;
				width: 11px;
				top: 34px;
				right: 8px;
				z-index: 10;
			}
			.swiper-button-prev {
				background: url(/images/icon-mo-next.svg) no-repeat;
				transform: rotate(180deg);
				width: 11px;
				top: 22px;
				left: 82%;
				z-index: 10;
			}
		}

		.article-wrap {
			margin-top: 60px;
			margin-left: 2px;
			.title {
				font-size: 22px;
				margin-bottom: 20px;
				margin-left: 10px;
			}
			.flex-wrap {
				flex-direction: column;
				.left-box {
					padding-right: 0;
					.line {
						margin: 30px 0;
					}
				}
			}
			.card-box {
				display: block;
				/* border-bottom: 1px solid #eee; */
				/* padding-bottom: 30px;
				margin-bottom: 30px; */
				&:last-child {
					padding-bottom: 0;
					margin-bottom: 0;
				}
			}
			.article-card {
				flex-wrap: wrap;
				gap: 16px;
				.cardimgbox {
					width: 100%;
				}
				.article-img {
					width: 100%;
					height: 0;
					padding-bottom: 55.4%;
					border-radius: 16px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
				}
				.text-box {
					max-width: 584px;
					width: 100%;
					margin-left: 10px;
					.tag-box {
						gap: 12px;
						.cate {
							font-size: 12px;
							font-weight: 400;
						}
					}
					h3 {
						margin-top: 6px;
						font-size: 18px;
						overflow: hidden;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
					}
					.content {
						margin-top: 8px;
						font-size: 12px;
						padding-right: 0px;
					}
					.flex {
						margin-top: 9px;
						p {
							font-size: 12px;
						}
						.name {
							font-size: 12px;
						}
						.date {
							font-size: 12px;
						}
					}
				}
			}
			.right-box {
				display: none;
			}
		}
		.result {
			height: 400px;
			.result-box {
				width: 220px;
				height: 132px;
				p {
					padding-top: 35px;
					font-size: 14px;
				}
			}
		}
		.btn-wrap {
			top: 0px !important;
			margin-top: 30px;
			.more {
				border-radius: 76px;
				width: 117px !important;
				height: 46px !important;
				p {
					font-size: 13px !important;
					font-weight: 600;
					line-height: 44px !important;
				}
			}
		}
	}
`;

export const MoSeries = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		display: block;
		margin-top: 55px;

		h2 {
			color: #000;
			font-size: 22px;
			font-weight: 700;
			line-height: 140%;
			margin-bottom: 20px;
			margin-left: 10px;
		}
		.series-wrap {
			max-width: calc(100% - 5px);
			overflow: visible;
			margin: 0 auto;
			.swiper {
				overflow: visible !important;
			}
		}

		.banner {
			width: 100%;
			height: 240px;
			background-repeat: no-repeat;
			background-position: center;
			background-size: cover;
			border-radius: 18px;
			padding: 28px;
			position: relative;
			.title {
				font-size: 18px;
				font-weight: 700;
				opacity: 0.6;
				font-family: 'GmarketSans';
			}
			.total {
				font-size: 13px;
				font-weight: 400;
				position: absolute;
				right: 28px;
				bottom: 28px;
				opacity: 0.6;
			}
		}
		.more-btn {
			width: 102px;
			height: 46px;
			margin: 30px auto 0 auto;
			.more {
				height: 100%;
				border-radius: 76px;
				border: 1px solid #eee;
				background: #fff;
				display: flex;
				gap: 8px;
				justify-content: center;
				img {
					width: 18px;
				}
				p {
					text-align: center;
					font-size: 13px;
					font-weight: 600;
					line-height: 44px;
				}
			}
		}
	}
`;

export const Banner = styled.div`
	background-image: url(${(props) => props.moThumbnail}) !important;
`;
